<template>
  <div class="classCompareReport">
    <knowledge-head :basicInfo='basicInfo' :classType='classType'/>
    <div class="classCompareReport__content">
      <knowledge-overview :overviewData="basicInfo"
      :classType="classType" class="content-bg"/>
      <knowledge-class-overview :overviewData="basicInfo.class_ranking_list"
      :rankingAvgScore="basicInfo.avg_ability" class="content-bg"/>
      <knowledge-study-level :overviewData="basicInfo.class_score_grade_list" class="content-bg"/>
      <knowledge-weak-point :overviewData="basicInfo" class="content-bg"/>
    </div>
  </div>
</template>

<script>
import KnowledgeHead from './components/knowledge-head.vue';
import KnowledgeOverview from './components/knowledge-overview.vue';
import KnowledgeClassOverview from './components/knowledge-class-overview.vue';
import KnowledgeStudyLevel from './components/knowledge-study-level.vue';
import KnowledgeWeakPoint from './components/knowledge-weak-point.vue';
import { getClassReportContrast } from '../../api/pt';

const CLASS_TYPE = 2; // 1为班级报告 2为班级对比报告
export default {
  name: 'ClassCompareReport',
  components: {
    KnowledgeHead,
    KnowledgeOverview,
    KnowledgeClassOverview,
    KnowledgeStudyLevel,
    KnowledgeWeakPoint,
  },
  data() {
    return {
      classType: CLASS_TYPE,
      basicInfo: {
        subject_name: '',
        subject_id: '',
        textbook_name: '',
        test_name: '',
        test_id: '',
        evaluate_name: '',
        total_stu: '',
        finish_stu: '',
        avg_ability: '',
        avg_right_rate: '',
        avg_cost_time: '',
        class_ranking_list: [], // 班级排名列表
        class_score_grade_list: [], // 班级掌握程度等级列表
        code_list: [], // 薄弱知识点列表（top10）
        finish_info: [], // 查看明细
      },
    };
  },
  methods: {
    getClassReportContrast() {
      const { schoolId, batchId } = this.$route.query;
      return getClassReportContrast({
        school_id: schoolId,
        batch_id: batchId,
      }).then((res) => {
        if (res.code === 200) {
          this.basicInfo = res.data;
        }
      });
    },

  },
  mounted() {
    this.getClassReportContrast();
  },
};
</script>

<style lang="scss" scoped>
.classCompareReport{
  box-sizing: border-box;
  width:100%;
  &__content{
    .content-bg{
      background-color: #ffffff;
    }
  }

}
</style>
